<template>
  <div class="ml-5 mr-5">
    <div class="text-right my-4">
      <loading :active.sync="isLoading" :can-cancel="false" loader="dots" color="#007bff" :height="45" :width="75"
        :is-full-page="fullPage"></loading>
    </div>
    <div class="text-right mb-3">
      <template>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">

            <v-btn small class="mx-2" color="primary" dark v-bind="attrs" v-on="on"
              v-show="checkIfOperationExistForModule('add')">
              Add
            </v-btn>
            <v-btn small class="mx-2" color="secondary" dark @click="openArchiveDialog">
              Archive
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Add Audience</span>
            </v-card-title>
            <v-form ref="addAudienceForm" @submit="addAudienceData" method="post" v-model="valid" lazy-validation>
              <v-container class="px-50 v-card-padding" fluid>
                <v-text-field v-model="addAudience.audienceName" label="Audience Name" :rules="nameRules"
                  required></v-text-field>
                <div style="color: red">
                  {{ message1 }}
                </div>
              </v-container>
              <v-container class="px-50" fluid> </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" type="submit">
                  Submit
                </v-btn>
                <v-btn class="close_button mx-2" text @click="reset"> Close </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog max-width="600" v-model="dialog2">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small color="error" v-bind="attrs" v-on="on" v-show="checkIfOperationExistForModule('delete')">Soft
            Delete</v-btn>
        </template>
        <div v-if="deleteItems.length > 0">
          <template>
            <v-card>
              <v-card-text>
                <div class="text-h3 pa-12">
                  Are you sure you want to delete all the selected Record(s)?
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-form ref="form" method="post">
                  <v-btn text class="confirm_button mx-2" v-on:click="dialog2 = false"
                    @click="deleteAudience">Yes</v-btn>
                </v-form>
                <v-btn class="close_button mx-2" text @click="dialog2 = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </div>
        <div v-if="deleteItems.length == 0">
          <template>
            <v-card>
              <v-card-text class="center">
                <div class="text-h3 pa-12">
                  Please Select Record(s)? to delete
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn class="close_button mx-2" text @click="dialog2 = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </div>
      </v-dialog>
    </div>
    <!-- v-data-table  -->
    <v-row>
      <v-col cols="12">
        <div class="tableWrapper">
          <div id="select-all-checkbox">
            <v-checkbox ref="n" v-model="allSelected" @click="selectAll"
              v-show="checkIfOperationExistForModule('delete')"></v-checkbox>
          </div>
          <v-data-table :headers="headers" item-key="product_id" :items="audience_data" :options.sync="options"
            :server-items-length="total" :loading="isLoading" class="elevation-1" hide-default-footer>
            <template v-slot:item.selectCheckbox="{ item }">
              <v-checkbox ref="n" v-model="deleteItems" :value="item.audience_id" :key="item.audience_id"
                @click="addToDelete($event, item.audience_id)"
                v-show="checkIfOperationExistForModule('delete')"></v-checkbox>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon medium color="grey" @click="addToUpdate($event, item.audience_id)"
                v-show="checkIfOperationExistForModule('edit')">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="toggleUpdateModal" max-width="600">
        <template>
          <v-card>
            <v-card-title>
              <span class="headline">Update Audience</span>
            </v-card-title>
            <v-form ref="form" @submit="updateAudienceData" method="put">
              <v-container class="px-50" fluid>
                <v-text-field v-model="updateAudience.audienceName" label="Audience Name" required
                  :rules="nameRules"></v-text-field>
                <div style="color: red">
                  {{ upmessage1 }}
                </div>
              </v-container>
              <v-container class="px-50" fluid> </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" @click="updateAudienceData" type="submit">
                  Update
                </v-btn>
                <v-btn class="close_button mx-2" text @click="toggleUpdateModal = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </template>
      </v-dialog>


      <v-dialog v-model="archiveDialog" max-width="650px">
        <v-card>

          <!-- Title -->
          <v-card-title class="justify-center">
            <span class="headline">Archived Audiences</span>
          </v-card-title>

          <!-- Action Buttons -->
          <div class="px-6 pb-2 mt-5" v-if="isAdmin">
            <v-row no-gutters class="align-center">
              <v-col cols="12" class="text-right">
                <v-btn small color="error" class="mr-2" @click="deleteArchivePermanently">
                  Delete
                </v-btn>
                <v-btn small color="primary" @click="restoreArchive">
                  Restore
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <!-- Table -->
          <v-data-table :headers="archiveHeaders" :items="archiveList" item-key="audience_id" dense hide-default-footer
            show-select v-model="selectedArchiveItems" />

          <!-- Empty message -->
          <div v-if="archiveList.length === 0" class="text-center grey--text py-4">
            No archived records found
          </div>

          <v-card-actions class="justify-end">
            <v-btn text @click="archiveDialog = false">Close</v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>

    </v-row>
    <!-- v-data-table-ends -->
  </div>
</template>

<script>
import axios from "axios";
import Index from "./Index.vue";
import Buttons from "./component/Buttons.vue";
import Item from "../../components/base/Item.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueCookies from "vue-cookies";
export default {
  components: { Index, Buttons, Loading },
  data() {
    return {
      toggleUpdateModal: false,
      //////table data starts here////
      selected: [],
      options: {},
      sort: "",
      total: 0,
      editReportMode: false,
      fromDateMenu: false,
      fromDateVal: null,
      // //  minDate: "2020-01-05",
      // //  maxDate: "2019-08-30",
      headers: [
        {
          text: "",
          value: "selectCheckbox",
          width: "50px",
          sortable: false,
          class: "v-data-table-header",
        },
        {
          text: "Audience Name",
          value: "audience_name",
          width: "200px",
          sortable: false,
          class: "v-data-table-header",
        },
        {
          text: "Action",
          value: "actions",
          width: "150px",
          sortable: false,
          class: "v-data-table-header",
        },
      ],
      ////// table data ends here
      archiveDialog: false,
      archiveList: [],               // store archived items
      selectedArchiveItems: [],      // store selected items in archive
      isAdmin: false,
      archiveHeaders: [
        { text: "Audience Name", value: "audience_name", sortable: false }
      ],

      valid: true,
      checkbox: false,
      isLoading: true,
      fullPage: true,
      audienceName: [],
      audience_data: [],
      dialog: false,
      dialog1: false,
      dialog2: false,
      deleteItems: [],
      checked_audienceId: [],
      checkcedstr: "",
      message1: "",
      message2: "",
      upmessage1: "",
      upmessage2: "",
      allSelected: false,
      addAudience: {
        audienceName: null,
      },
      updateAudience: {
        audienceId: null,
        audienceName: null,
      },
      checked: false,
      nameRules: [(v) => !!v || "Name is required"],
      addAudiencelabel: null,
    };
  },

  methods: {
    checkIfOperationExistForModule(type) {
      return this.$utils.checkIfOperationExistForModule(this, type)
    },
    validate() {
      this.$refs.form.validate();
    },
    openArchiveDialog() {
      this.archiveDialog = true;
      this.getArchivedAudience(); // 👈 separate function
    },
    getArchivedAudience() {
      let view = this;
      const path = this.$url("AUDIENCE");

      view.isLoading = true;

      this.$fetch({ requiresAuth: true, operation: 'view', vueScope: view })
        .get(path, {
          params: {
            is_deleted: true
          }
        })
        .then((res) => {
          view.isLoading = false;

          const data = res.data.payload.audienceId || [];

          this.archiveList = data.map(item => ({
            audience_id: item[0],
            audience_name: item[1],
          }));
        })
        .catch((error) => {
          console.error(error);
          view.isLoading = false;
        });
    },
    restoreArchive() {
      if (this.selectedArchiveItems.length === 0) {
        this.$swal.fire("Select record(s) to restore");
        return;
      }

      let view = this;
      view.isLoading = true;

      const ids = this.selectedArchiveItems.map(
        item => Number(item.audience_id)
      );

      this.$fetch({ requiresAuth: true, operation: 'edit', vueScope: view })
        .post(this.$url("RESTORE_AUDIENCE"), { ids })
        .then((res) => {
          view.isLoading = false;

          if (res.data && res.data.statusCode === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Record(s) restored successfully",
              text: res.data.payload?.message || "Restored",
            });
            this.getAudience();
            this.getArchivedAudience();
            this.selectedArchiveItems = [];
            this.archiveDialog = false;
          }
        })
        .catch((err) => {
          view.isLoading = false;
          console.error("Restore error:", err);

          this.$swal.fire({
            icon: "error",
            title: "Restore failed",
            text: "Something went wrong",
          });
        });
    },

    deleteArchivePermanently() {
      if (this.selectedArchiveItems.length === 0) {
        this.$swal.fire("Select record(s) to delete");
        return;
      }

      let view = this;
      view.isLoading = true;

      const ids = this.selectedArchiveItems.map(
        item => Number(item.audience_id)
      );

      this.$fetch({ requiresAuth: true, operation: 'delete', vueScope: view })
        .delete(this.$url("AUDIENCE"), {
          params: {
            id: ids,
            soft: false
          }
        })
        .then((res) => {
          view.isLoading = false;

          if (res.data && res.data.statusCode === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Record(s) deleted permanently",
              text: res.data.payload?.message || "Deleted",
            });
            this.getAudience();
            this.getArchivedAudience();
            this.selectedArchiveItems = [];
            this.archiveDialog = false;
          }
        })
        .catch((err) => {
          view.isLoading = false;
          console.error("Permanent delete error:", err);

          this.$swal.fire({
            icon: "error",
            title: "Delete failed",
            text: "Something went wrong",
          });
        });
    },


    reset() {
      this.dialog = false;
      this.dialog1 = false;
      this.message1 = "";
      this.upmessage1 = "";
      if (this.$refs.addAudienceForm) {
        this.$refs.addAudienceForm.resetValidation();
        this.$refs.addAudienceForm.reset();
      }
    },
    getAudience() {
      const path = this.$url("AUDIENCE");
      this.isLoading = true;
      this.$fetch({ requiresAuth: true, operation: 'view', vueScope: this })
        .get(path)
        .then((res) => {
          this.isLoading = false;
          this.audienceName = res.data.payload.audienceId;
          this.total = this.audienceName.length;
          if (Array.isArray(this.audienceName) && this.audienceName.length) {
            this.audience_data = [];
            let i;
            for (i = 0; i < this.audienceName.length; i++) {
              let tempobj = {
                audience_id: this.audienceName[i][0],
                audience_name: this.audienceName[i][1],
              };
              this.audience_data.push(tempobj);
            }
          } 
        })
        .catch((error) => {
          console.error(error);
        });
    },
    addAudienceData(e) {
      e.preventDefault();
      let view = this;
      if (!this.$refs.addAudienceForm.validate()) {
        view.isLoading = false;
        return;
      }
      view.isLoading = true;
      if (
        this.addAudience.audienceName != "" &&
        this.addAudience.audienceName != null
      ) {
        this.$fetch({ requiresAuth: true, operation: 'add', vueScope: view })
          .post(this.$url("AUDIENCE"), view.addAudience)
          .then((result) => {
            view.isLoading = false;
            let statusCode = result.data.statusCode;
            if (statusCode === 200) {
              view.getAudience();
              view.reset();
            } else {
              let payload = result.data.payload;
              let message = (payload && payload.message) ? payload.message : "Something went wrong!";
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: message,
              });
            }
          })
          .catch((error) => {
            console.error(error);
            view.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong!",
            });
          });
      }
    },
    addToUpdate(e, atchid) {
      this.toggleUpdateModal = true
      this.audienceName.forEach(function (o, i) {
        if (o[0] == atchid) {
          this.updateAudience.audienceName = o[1];
          this.updateAudience.audienceId = o[0];
        }
      });
    },
    updateAudienceData(e) {

      e.preventDefault();
      let data = this;
      data.isLoading = true
      if (
        data.updateAudience.audienceName != "" &&
        data.updateAudience.audienceName != null
      ) {
        this.$fetch({ requiresAuth: true, operation: 'edit', vueScope: data })
          .put(data.$url("AUDIENCE"), data.updateAudience)
          .then((result) => {
            data.isLoading = false
            this.upmessage1 = result.data.payload.audienceId;
            this.upmessage2 = result.data.payload.audienceName;
            if (this.upmessage2 == null) {
              this.upmessage1 = result.data.payload.audienceId;
              this.dialog1 = true;
            } else {
              this.upmessage1 = null;
              this.dialog1 = false;
              if (result.data.statusCode == 200 && this.upmessage1 == null) {
                this.$swal.fire({
                  icon: "success",
                  title: "Record(s) updated successfully",
                  text: result.data.payload.message,
                });
                this.toggleUpdateModal = false
              }
              this.getAudience();
              this.reset();
            }

            console.log(result);
          }).catch((error) => {
            console.error(error);
            data.isLoading = false
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong!",
            });
          });
      }
    },
    addToDelete(e, atchid) {
      this.checkedthis = false;
      if (e.target.checked) {
        if (this.checked_audienceId.indexOf(e.target.value) == -1) {
          this.checked_audienceId.push(e.target.value);
        }
      } else {
        this.checked_audienceId.splice(
          this.checked_audienceId.indexOf(e.target.value),
          1
        );
      }
      let checkcedstr = this.checked_audienceId.join(",");
      this.checkcedstr = checkcedstr;
      console.log(this.checkcedstr);
    },
    deleteAudience(e) {
      e.preventDefault();
      this.isLoading = true
      console.log(this.deleteItems);
      this.$fetch({ requiresAuth: true, operation: 'delete', vueScope: this })
        .delete(this.$url("AUDIENCE"), {
          params: {
            soft: true,
            id: this.deleteItems,
          }
        })
        .then((response) => {
          this.isLoading = false
          if (response.data.statusCode == 200) {
            this.$swal.fire({
              icon: "success",
              title: "Selected record(s) has been deleted",
              text: response.data.payload.message,
            });
          }
          this.getAudience();
          this.deleteItems = [];
        }).catch((error) => {
          console.error(error);
          this.isLoading = false
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          });
        });
    },
    selectAll: function () {
      let audiences = this.audienceName;
      if (this.allSelected == true) {
        if (Array.isArray(audiences) && audiences.length) {
          this.deleteItems = [];
          let i;
          for (i = 0; i < audiences.length; i++) {
            console.log(audiences[i]);
            this.deleteItems.push(audiences[i][0]);
          }
        }
      } else if (this.allSelected == false) {
        this.deleteItems = [];
      }
    },
    select: function () {
      this.allSelected = false;
    },
    submit() {
      this.$v.$touch();
    },
  },
  created() {
    const userRole = VueCookies.get("user_role");
    this.isAdmin = Number(userRole) === 1;
  },
  watch: {
    '$store.state.Rawdata.current_active_module': function (o) {
      if (o) {
        this.getAudience(1);
      }
    },
  },
};
</script>
